import { useTranslation } from 'react-i18next';
import { SearchOption } from '../../../../redux/store/content/types';
import { getSearchUrl } from '../../../../shared/urlBuilder';
import { useAppSelector } from '../../../../redux/hooks';
import { selectSelectedCategoryIdsForSearch } from '../../../../redux/store/content/slice';

export default function useSearchSuggestions(searchString: string) {
  const { t } = useTranslation();
  const selectedCategoryIds = useAppSelector(
    selectSelectedCategoryIdsForSearch,
  );

  return [
    {
      label: `${t('allWords')}: ${searchString}`,
      searchOption: SearchOption.AllWords,
      href: getSearchUrl(
        searchString,
        SearchOption.AllWords,
        false,
        selectedCategoryIds,
      ),
    },
    {
      label: `${t('exactExpression')}: ${searchString}`,
      searchOption: SearchOption.ExactExpression,
      href: getSearchUrl(
        searchString,
        SearchOption.ExactExpression,
        false,
        selectedCategoryIds,
      ),
    },
  ];
}
